
import { ref } from '@nuxtjs/composition-api';
import tinycolor from 'tinycolor2'

export default {
  props: {
    colors: {
      type: Array,
      default: () => []
    },
    activeColor: {
      type: String,
      default: ''
    },
    activeColorName: {
      type: String,
      default: ''
    },
    colorSelectionEnabled: {
      type: Boolean,
      default: true
    },
    colorNameCentered: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const isDark = value => {
      const color = tinycolor(value)
      return color.isDark()
    }
    return {
      isDark,
      selected: ref(props.colors.indexOf(props.activeColor))
    }
  }
}
